const config = {
   ENDPOINT: "https://eop-rest-service-gpu3isiisq-uc.a.run.app"
   //ENDPOINT: "http://localhost:8080"
}

export default config;